import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { usersApi } from '../../api/users';
import { GQLArgs } from '../../types';

type RemoveUserResponse = { removeUser: { message: string } };

export const useMutationRemoveUser = (args?: GQLArgs<RemoveUserResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<RemoveUserResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: { email: string } }) => {
      setLoading(true);
      try {
        const listRes = await usersApi.list({ search: variables.email, per_page: 1 });
        const userId = listRes.data.nodes[0]?.id;
        if (!userId) throw new Error('User not found');

        await usersApi.remove(userId);
        const shaped: RemoveUserResponse = { removeUser: { message: 'ok' } };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('User has been removed', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
